import createHistory from 'history/createBrowserHistory';

// import trace from '../app/trace' ;

const history = createHistory();

// history.listen( (location, action) =>
// {
//     trace( `[HISTORY] - ${location.pathname}${location.search}${location.hash} - ${action}` , true ) ;
// });

export default history ;




// WEBPACK FOOTER //
// ./src/@fuse/history.js